import './styles/community.css';
import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadMe } from './actions/authActions';

import Header from './components/Header';
import FrameworkBanner from './components/FrameworkBanner';
import Home from './pages/Home';
import Inventory from './pages/Inventory';
import MembershipDetail from './pages/MembershipDetail';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import AcceptInvite from './pages/AcceptInvite';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import AdminUsers from './pages/admin/Users';
import AdminInvites from './pages/admin/Invites';
import AdminRoles from './pages/admin/Roles';
import ApiKeys from './pages/account/ApiKeys';
import Docs from './pages/Docs';
import Questions from './pages/Questions';
import QuestionDetail from './pages/QuestionDetail';
import AskQuestion from './pages/AskQuestion';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import WriteArticle from './pages/WriteArticle';

function ProtectedRoute({ children, roles }) {
  const { user } = useSelector(s => s.auth);
  // While loadMe() is still resolving the persisted token, render a loading shell
  // instead of bouncing to /login. The token's presence tells us a session is in-flight.
  const hasPersistedToken = typeof window !== 'undefined' && !!localStorage.getItem('auth_token');
  if (!user) {
    if (hasPersistedToken) return <div className="section narrow"><p className="muted">Loading…</p></div>;
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role) && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  const dispatch = useDispatch();
  useEffect(() => { dispatch(loadMe()); }, [dispatch]);
  return (
    <>
      <FrameworkBanner />
      <Header />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/memberships/:id" element={<MembershipDetail />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/questions/ask" element={<AskQuestion />} />
          <Route path="/questions/:slug" element={<QuestionDetail />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/new" element={<WriteArticle />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route path="/accept-invite/:token" element={<AcceptInvite />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/account/api-keys" element={<ProtectedRoute><ApiKeys /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={['manager','admin']}><Admin /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute roles={['manager','admin']}><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/invites" element={<ProtectedRoute roles={['manager','admin']}><AdminInvites /></ProtectedRoute>} />
          <Route path="/admin/roles" element={<ProtectedRoute roles={['admin']}><AdminRoles /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer className="app-footer">
        <p>HR without Borders — a Free Builder reference demo. <a href="/docs">Docs</a> · <a href="https://free-builder.com/">free-builder.com</a></p>
      </footer>
    </>
  );
}
